module.exports = __webpack_public_path__ + "img/eyes.0221b5a9.svg";